import { SignIn } from '@clerk/react';
import { ShieldAlert } from 'lucide-react';

export function SignInPage() {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-primary-600 p-12 flex-col justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white">notlegal.chat</h1>
          <p className="text-primary-200 mt-2">Where we give you <span className="italic">not legal advice</span> since 2024</p>
        </div>
        <div className="space-y-6">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-primary-500 rounded-2xl flex items-center justify-center flex-shrink-0">
              <ShieldAlert className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-white font-semibold">World-Class Disclaimers</h3>
              <p className="text-primary-200 text-sm mt-1">
                Every response comes with disclaimers so comprehensive, even lawyers are impressed.
              </p>
            </div>
          </div>
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-primary-500 rounded-2xl flex items-center justify-center flex-shrink-0">
              <ShieldAlert className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-white font-semibold">100% Entertainment Value</h3>
              <p className="text-primary-200 text-sm mt-1">
                Results not guaranteed. Side effects may include mild amusement and false confidence.
              </p>
            </div>
          </div>
        </div>
        <p className="text-primary-300 text-sm">
          By signing in, you agree that you understand this is not legal advice.
          If you didn't understand that, please leave immediately.
        </p>
      </div>

      {/* Right side - Sign In Form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <SignIn
            appearance={{
              elements: {
                rootBox: 'mx-auto',
                card: 'shadow-soft',
              },
            }}
            fallbackRedirectUrl="/chat"
          />
        </div>
      </div>
    </div>
  );
}
